



























import Vue from 'vue';
import NewAssignment from '@/dialog/NewAssignment.vue';
import { getAssignmentList, Assignment } from '@/repository/assignment';

export default Vue.extend({
  components: {
    NewAssignment,
  },
  data: () => ({
    assignments: new Array<Assignment>(),
    isLoading: true,
  }),
  methods: {
    log(i: any) {
      console.log(i);
    },
    loadData() {
      this.isLoading = true;
      getAssignmentList().then((result) => {
        this.assignments = result;
        this.isLoading = false;
      });
    },
  },
  beforeMount() {
    this.loadData();
  },
});
